import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIdenticon10 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 5,
			height: 5,
			stroke: "currentColor",
			strokeOpacity: .5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 9,
			width: 4,
			height: 4,
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8.5,
			y: 16.5,
			width: 5,
			height: 5,
			stroke: "currentColor",
			strokeOpacity: .5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: 16.5,
			width: 5,
			height: 5,
			stroke: "currentColor",
			strokeOpacity: .5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9,
			y: 1,
			width: 4,
			height: 4,
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9,
			y: 9,
			width: 4,
			height: 4,
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 25,
			width: 4,
			height: 4,
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8.5,
			y: 24.5,
			width: 5,
			height: 5,
			stroke: "currentColor",
			strokeOpacity: .5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16.5,
			y: 8.5,
			width: 5,
			height: 5,
			stroke: "currentColor",
			strokeOpacity: .5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 17,
			y: 1,
			width: 4,
			height: 4,
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 17,
			y: 17,
			width: 4,
			height: 4,
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16.5,
			y: 24.5,
			width: 5,
			height: 5,
			stroke: "currentColor",
			strokeOpacity: .5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 24.5,
			y: .5,
			width: 5,
			height: 5,
			stroke: "currentColor",
			strokeOpacity: .5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 24.5,
			y: 16.5,
			width: 5,
			height: 5,
			stroke: "currentColor",
			strokeOpacity: .5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 25,
			y: 9,
			width: 4,
			height: 4,
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 25,
			y: 25,
			width: 4,
			height: 4,
			stroke: "currentColor",
			strokeWidth: 2
		})
	]
});
export { SvgIdenticon10 as ReactComponent };
